// extracted by mini-css-extract-plugin
module.exports = {"toppingAmountModifierItem":"US2RA"};